import indigo from '@material-ui/core/colors/indigo';
import blue from '@material-ui/core/colors/blue';
import deepOrange from '@material-ui/core/colors/deepOrange';

export const INDIGO = 'INDIGO';
export const BLUE = 'BLUE';
export const DEEP_ORANGE = 'DEEP_ORANGE';

// Map the Material UI color object by name
export const muiColorByName = {
  [INDIGO]: indigo,
  [BLUE]: blue,
  [DEEP_ORANGE]: deepOrange
};